import '../../App.less';
import { Layout, Row, Col,ConfigProvider,Table,Modal,Menu,Input, Space, AutoComplete,notification, Select } from 'antd';
import React, { Component, Fragment } from "react";
import cabezal from '../Cabezal.jpg'
import 'react-phone-input-2/lib/style.css'
import es_ES from 'antd/lib/locale/es_ES';
import {NavLink} from "react-router-dom";
import { Button } from 'antd';
import Highlighter from 'react-highlight-words';
import { SearchOutlined, UserOutlined,HomeOutlined,EditOutlined,TeamOutlined,FileTextOutlined,ReadOutlined,DownloadOutlined,MailOutlined, PhoneOutlined, GlobalOutlined, EnvironmentOutlined, IdcardOutlined,LogoutOutlined,BarChartOutlined } from '@ant-design/icons';
import moment from 'moment'
import { Document, Page } from 'react-pdf';
import axios from "axios";
import countries from '../../static/json/countries.json'
import generatePDFConc from './services/reportGenerator' 
import generatePDFPlay from './services/reportGeneratorPlays'
import Navbar from '../components/NavBar' 


class ConcList extends Component {
  constructor(props){
    super(props)
    const { Option } = Select;
    this.state={
      phone: '',
      sended: false,
      showRegistrate: false,
      plays:[],
      fileList: [],
      authors:[],
      edit:false,
      countryCode:'',
      countryName:'',
      countrychanged:'',
      plays_report:[],
      filteredInfo:[],
      makeGenreReport:false,
      reportGenre:'Novela',
      reportCountry:null,
      makeCountryReport:false
    }
    // const promise = axios.get('https://back.premiocasa.cult.cu/api/casa/genero/')
    // const dataPromise = promise.then((response)=> response.data)
    // console.log(dataPromise)
  }
  getAuthors(auth){
    var authors = []
    for (var i in auth){
     authors.push({id:i,
       name: auth[i]["nombre_completo"]} )
    }
   return authors

 }
 getAuthorsStr(auth){
   var authors = []
   for (var i in auth){
    authors.push( auth[i]["nombre_completo"])
    
   }
  return authors

}
getCountryName(country){
  for(var c in  countries["countries"]){
    if (countries["countries"][c]["code"]==country)
      return countries["countries"][c]["name_es"]
  }
  return "No name"
}
async componentWillMount() {
    
  const response_plays = await fetch('https://back.premiocasa.cult.cu/api/casa/obra/',{
    method: "get",
    credentials: "same-origin",
    headers: {
      "Authorization": localStorage.getItem("Authorization") ,
      "Accept": "application/json",
      "Content-Type": "application/json"
  },
  });
  var data_play = []
  const json_plays = await response_plays.json();
  console.log("AAAA",json_plays)
  const json =[].concat.apply([],json_plays.map(play=> {return play.conc})) ;
  console.log("BBB",json)
  console.log(json)
  if(json_plays['detail']){
    localStorage.clear()
    window.location.reload(); 
  }
  const genr = await fetch('https://back.premiocasa.cult.cu/api/casa/genero/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    this.json_g = await genr.json();
    this.genres_dict = {};
    this.json_g.forEach(element => {
      this.genres_dict[element.id] = element.nombre
    });
  var data = []
  const Moment = require('moment');
  for(var i in json_plays){
    var item = json_plays[i];
    // const pdf = await fetch('/api/file/'+i);
    console.log(item)
    var date= new Moment(item.fecha_registro).format('DD-MM-YYYY')
    var author= this.getAuthors(item.conc)
    var a= this.getAuthorsStr(item.conc)
  
    
    var authorStr = this.getAuthorsStr(item.conc).join(", ")
    const year = date.split('-')[2]
    data_play.push(
        { 
            id : i,
            title : item.titulo,
            author: author ,
            authorStr:authorStr,
            date:date,
            pseudo: item.pseudonimo,
            code:year+'_'+item.genero+'_'+item.id,
            conc:item.conc,
            // date:'',
            category:this.genres_dict[item.genero],
            pdf:item.pdf,
            edit:''
        });
  };



  
  var data = []

  this.names = new Set();
  this.emails = new Set();
  this.countries = new Set();
  console.log("PPPPPPPPPPPPP",json)
  for(var i in json){
    var item = json[i];
    console.log("PPOPOPASODASD",item)
    this.names.add(item.nombre_completo)
    this.emails.add(item.email)
    this.countries.add(item.pais)
    data.push(
        { 
            id : item.id,
            name : item.nombre_completo,
            country: item.pais,
            countryName:this.getCountryName(item.pais),
            ficha: item.ficha,
            phone: item.telefono,
            address: item.direcc_personal,

            // date:new Moment(item.start_publication).format('YYYY-MM-DD'),
            email: item.email,
        });
  };
  this.setState({ plays: data, plays_report:data_play, filteredInfo: data });

  this.names = [...this.names].map((v)=>{
    return {value:v}
  })
  this.emails =[...this.emails].map((v)=>{
    return {value:v}
  })
  this.countries = [...this.countries].map((v)=>{
    return {value:v}
  })

}

  onChangeSelect(value){
    this.setState({countrychanged:value})
  }

  handleTableChange = (pagination, filters, sorter, extra) => {
    console.log('Various parameters', extra.currentDataSource);
    this.setState({
      filteredInfo: extra['currentDataSource']
    });
  }

  getCountryCode(country){
    for(var c in  countries["countries"]){
      if (countries["countries"][c]["name_es"]==country)
        return countries["countries"][c]["code"]
    }
    return "No code"
  }
  getAutocomplete = (dataIndex) =>{
    console.log(this.codes)
    if(dataIndex == "code"){
      return this.codes
    }
    
      else if (dataIndex == "name" ) {
        return this.names
    } 

    else if (dataIndex== "email"){
      return this.emails
    }
    else{
      return this.countries
    }
  }
  onClickArticle = record  => {
    console.log(record)
        this.setState({showArticle:true,record:record});
  };

  async onClickSave(){

    console.log("PPPPP")
    console.log(this.state.categoryChanged)
    var options = {
       method: "patch",
       credentials: "same-origin",
       headers: {
         "Authorization": localStorage.getItem("Authorization") ,
         "Accept": "application/json",
         "Content-Type": "application/json"},
      
     }
     // id : i,
     // title : item.titulo,
     // author: author ,
     // date:date,
     // pseudo: item.pseudonimo,
     // code:item.code,
     // // date:'',
     // category:item.genero.nombre,
     // pdf:item.pdf
     // console.log(document.getElementById("inputPseudo").value)

     
    //  <p><UserOutlined /> Nombre:<Input defaultValue= {this.state.record.name} id="nameInput" /> </p>
    //  <p><MailOutlined /> Email:<Input defaultValue= {this.state.record.email} id="emailInput" /></p>
    //  <p><PhoneOutlined /> Teléfono: <Input defaultValue= {this.state.record.phone} id="emailInput" /> </p>
    //  <p><GlobalOutlined /> País: <Select style={{width:'80%'}} >
    //            {countries["countries"].map((obj)=>{
    //              return <Option value={obj["code"]}>{obj["name_es"]}</Option>
    //          })}
                 
    //            </Select> </p>
    //  <p><EnvironmentOutlined /> Dirección: <Input defaultValue= {this.state.record.address} id="addressInput" /></p>
    //  <p><IdcardOutlined /> Ficha: <Input defaultValue= {this.state.record.ficha} id="fichaInput" /></p>
     
    var concChanged={
      nombre_completo: document.getElementById("nameInput").value,
      email: document.getElementById("emailInput").value,
      telefono: document.getElementById("phoneInput").value,
      pais:document.getElementById("nameInput").value,
      direcc_personal:document.getElementById("addressInput").value,
      ficha:document.getElementById("fichaInput").value,
      pais:this.state.countrychanged?this.state.countrychanged:this.state.record.country,
    }
     
     await axios.patch(`https://back.premiocasa.cult.cu/api/concursantes/${this.state.record.id}/`, concChanged, options)
     .then(
       (response) => {
         console.log(response);
         if(response.status === 200)
            window.location.reload()
          else{
            notification.error({
            message:'Error',
            description:'Hubo un error, por favor revise los datos',
          });
          }
       },
       (error) => {
        //  const message = await error.json()
        //  var errors = []
         
        //  console.log(message)
        //  errors.join(", ")
        notification.error({
          message:'Error',
          description:'Hubo un error, por favor revise los datos',
        })
       }
     ).catch((err) => 
      console.log(err)
     
     )
     
   }

  onClickEditPlay= record  => {
    console.log(record)
        this.setState({edit:true,record:record,});
  };
  hideModal = () => {
        this.setState({
          showArticle: false,
          record: null,
        });
  };

  hideEdit = () => {
    this.setState({
      edit: false,
      record: null,
    });
};
  getColumnSearchProps = (dataIndex,name) => dataIndex!='edit' && ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => ( dataIndex!='edit' &&
          <div style={{ padding: 8 }}>
            <AutoComplete 
            style={{ width: 188, marginBottom: 8, display: 'block' }}
            options={this.getAutocomplete(dataIndex)}
            filterOption={(inputValue,option)=>option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
            onChange={(value)=>{setSelectedKeys(value ? [value] : [])}}
            value={selectedKeys[0]}

            >
             <Input
               ref={node => {
                this.searchInput = node;
              }}
              placeholder={`Buscar ${name}`}
              onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            />
            </AutoComplete>
            <Space>
              <Button
                type="primary"
                onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90 }}
              >
                Buscar
              </Button>
              <Button onClick={() => this.handleReset(clearFilters)} size="small" type="reset" style={{ width: 90 }}>
                Resetear
              </Button>
    
            </Space>
          </div>
        ),
        filterIcon: filtered =>dataIndex!='edit' && <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
          record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : '',
        onFilterDropdownVisibleChange: visible => {
          if (visible && dataIndex!= 'edit') {
            setTimeout(() => this.searchInput.select(), 100);
          }
        },
        render: (text,record,index) =>
          this.state.searchedColumn === dataIndex ? (
            <div style={{fontSize:'large' }}>
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
            </div>
          ) : (
            <div  style={{fontSize:'large' }}>
            {(dataIndex=='edit' && <a onClick={()=>{this.onClickEditPlay(record)}}> <EditOutlined /></a>)||
            <a onClick = {()=>this.onClickArticle(record)} >  {text} </a>}
            </div>
          ),
      });
    
      handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        console.log("HANDLE")
        console.log(selectedKeys)
        this.setState({
          searchText: selectedKeys[0],
          searchedColumn: dataIndex,
        });
      };
    
      handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
      };
      async logout(){
        await fetch('https://back.premiocasa.cult.cu/api/logout',{
          method: "post",
          credentials: "same-origin",
          headers: {
            "Authorization": localStorage.getItem("Authorization") ,
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        }).then(result=>{
          if(result.status == 200){
            var userId = localStorage.getItem("UserId")
            const data_log= new FormData()
            data_log.append('usuario',userId)
            data_log.append('accion',"Salida del sistema")
          
            axios.post('https://back.premiocasa.cult.cu/api/casa/logs/', data_log)
            localStorage.clear()
            window.location.reload(); 
          }
          else{
            notification.error({
          message:'Error',
          description:'Hubo un error, por favor intente más tarde',
        })}
        })
      }

      

  render() {
    const generateReport =()=> generatePDFConc(this.state.plays)
    const downloadPlayReport =()=> generatePDFPlay(this.state.plays_report,"save")
    const readPlayReport =()=> generatePDFPlay(this.state.plays_report,"read")
    
    const downloadCurrentReport =()=> generatePDFConc(this.state.filteredInfo,"save")
    const readCurrentReport =()=> generatePDFConc(this.state.filteredInfo,"read")
    
    const downloadConcReport =()=> generatePDFConc(this.state.plays,"save")
    const readConcReport =()=> generatePDFConc(this.state.plays,"read")

    const downloadPlayReportSelectedCountry=()=> generatePDFPlay(this.state.plays_report.filter(p=>Object.entries(p.conc)[0][1]['pais'] == this.getCountryCode(this.state.reportCountry)),"save",false,true,this.state.reportCountry)
const readPlayReportSelectedCountry =()=> generatePDFPlay(this.state.plays_report.filter(p=>Object.entries(p.conc)[0][1]['pais'] == this.getCountryCode(this.state.reportCountry)),"read",false,true,this.state.reportCountry)

const downloadPlayReportGenre =()=> generatePDFPlay(this.state.plays_report.filter(p=>p.category == this.state.reportGenre),"save")
const readPlayReportGenre =()=> generatePDFPlay(this.state.plays_report.filter(p=>p.category == this.state.reportGenre),"read")


const onClickGenreReport=()=>{
  this.setState({makeGenreReport:true})
}
const onClosekGenreReport=()=>{
  this.setState({makeGenreReport:false})
}
const onChangeReportGenre = (value) =>{this.setState({reportGenre:value})}


const onClickCountryReport=()=>{
  this.setState({makeCountryReport:true})
}
const onClosekCountryReport=()=>{
  this.setState({makeCountryReport:false})
}
const onChangeReportCountry = (value) =>{this.setState({reportCountry:value})}
    
    const centerStyle = {
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      marginLeft:'203px'
    };
      const { Header, Footer, Content } = Layout;
      const Moment = require('moment');
      const columns = [
                {
                    title: <div style={{fontWeight:'bold', fontSize:'large' }}>Nombre</div>,
                    dataIndex: 'name',
                    key: 'name',
                    sorter: (a, b) => a.name.localeCompare(b.name),
                    sortDirections:['ascend', 'descend', 'ascend'],
                    ...this.getColumnSearchProps('name','nombre'),
                    responsive: ['sm'] 
                  },
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Email</div>,
                    dataIndex: 'email',
                    key: 'email',
                    sorter: (a, b) => a.email.localeCompare(b.email),
                    sortDirections:['ascend', 'descend', 'ascend'],
                    ...this.getColumnSearchProps('email','e-mail'),
                    responsive: ['sm'] 

                  },
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>País</div>,
                    dataIndex: 'countryName',
                    key: 'countryName',
                    width:'10%',
                    sorter:(a,b) => a.country.localeCompare(b.country),
                    sortDirections:['ascend', 'descend', 'ascend'],
                    ...this.getColumnSearchProps('countryName','país'),
                    responsive: ['sm'] 
                  },
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Editar</div>,
                    dataIndex: 'edit',
                    key: 'edit',
                    width:'5%',
                    render: (text,record) =>(
                                <div  style={{fontSize:'large' }}>
                                <a onClick={()=>{this.onClickEditPlay(record)}}> <EditOutlined /></a>
                                </div>
                    ),
                    // sorter:(a,b) => new Moment(a.date).format('YYYYMMDD') - new Moment(b.date).format('YYYYMMDD'),
                    sortDirections:['ascend', 'descend', 'ascend'],
                    responsive: ['sm'] 
                  },
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large' }}>Concursante</div>,
                    sorter: (a, b) => a.name.localeCompare(b.name),
                    sortDirections:['ascend', 'descend', 'ascend'],
                    ...this.getColumnSearchProps('name','nombre'),
                    render: (record) => (
                      <React.Fragment>
                        <a onClick = {()=>this.onClickArticle(record)} >   
                        <b style={{fontSize:'large'}}>{record.name}</b>
                        </a>

                        <br />
                        <b>Email:</b>{record.email}
                        <br />
                        <b>País:</b>{record.countryName}
                      </React.Fragment>
                    ),
                    responsive: ['xs'] 
                  },
                  {
                    dataIndex: 'edit',
                    key: 'edit',
                    width:'15%',
                    render: (text,record) =>(
                                <div  style={{fontSize:'large' }}>
                                <a onClick={()=>{this.onClickEditPlay(record)}}> <EditOutlined /></a>
                                </div>
                    ),
                    // sorter:(a,b) => new Moment(a.date).format('YYYYMMDD') - new Moment(b.date).format('YYYYMMDD'),
                    sortDirections:['ascend', 'descend', 'ascend'],
                    responsive: ['xs'] 
                  },
                  


                 
            ];

            const content=(
              <div>
              <Button key="back" onClick={this.hideModal}> <ReadOutlined />Read</Button>
              <Button key="back" onClick={this.hideModal}> <DownloadOutlined />Download</Button>
        
              </div>
        
            );
            const { SubMenu } = Menu;

            const menu = (
              <Menu style={{height:'140'}} mode="inline">
              <Menu.Item key="home" icon={<HomeOutlined style={{ fontSize: '26px'}}/>} >
              <NavLink  style={{fontSize:'20px', fontWeight:'bold'}} to="/casa/admin"> Inicio</NavLink>
              </Menu.Item>
              <Menu.Item key="plays" icon={<FileTextOutlined style={{ fontSize: '26px'}} />}>
              <NavLink  style={{fontSize:'20px', fontWeight:'bold'}} to="/casa/admin_plays_list"> Obras</NavLink>
              </Menu.Item>
              <Menu.Item key="conc" icon={<UserOutlined style={{ fontSize: '26px'}} />}>
              <NavLink style={{fontSize:'20px', fontWeight:'bold'}} to='/casa/admin_conc_list'> Concursantes  </NavLink>
              </Menu.Item>
              <SubMenu key="reports" icon={<BarChartOutlined style={{ fontSize: '26px'}} />} style={{fontSize:'20px', fontWeight:'bold', color:'black'}} title="Reportes">
              <SubMenu  key="play" title ={<h4 style={{ fontWeight:'bold', color:'black'}}>Reportes de obras</h4>}>
                     
                          
                     <Menu.ItemGroup title={<h4 style={{  color:'black'}}>General</h4>}>
                       <Menu.Item>
                           <Button onClick={readPlayReport}>Ver</Button> <Button onClick={downloadPlayReport}>Descargar</Button>
                       </Menu.Item>
                     </Menu.ItemGroup>
    
                   
    
                  
             </SubMenu>
             <SubMenu  key="conc" title = {<h4 style={{ fontWeight:'bold', color:'black'}}>Reportes de concursantes</h4>}>
               <Menu.ItemGroup style={{ fontWeight:'bold'}} title={<h4 style={{  color:'black'}}>General</h4>}>
                 <Menu.Item>
                   <Button onClick={readConcReport}>Ver</Button> <Button onClick={downloadConcReport}>Descargar</Button>
                 </Menu.Item>
               </Menu.ItemGroup>
                  
               <Menu.ItemGroup title={<h4 style={{  color:'black'}}>Tabla actual</h4>}>
                       <Menu.Item>
                           <Button onClick={readCurrentReport}>Ver</Button> <Button onClick={downloadCurrentReport}>Descargar</Button>
                       </Menu.Item>
                     </Menu.ItemGroup>
             </SubMenu>
              </SubMenu>
               <SubMenu key="jury" icon={<TeamOutlined  style={{ fontSize: '26px'}} />} style={{fontSize:'20px', fontWeight:'bold', color:'black'}} title="Jurado">
            <Menu.Item>
            <NavLink style={{fontSize:'16px', fontWeight:'bold'}} to='/casa/admin_jurado'> Todo  </NavLink>
            </Menu.Item>
            <Menu.Item>
            <NavLink style={{fontSize:'16px', fontWeight:'bold'}} to='/casa/admin_jurado_poe'> Poesía  </NavLink>
            </Menu.Item>

            <Menu.Item style={{ fontWeight:'bold'}} >
            <NavLink style={{fontSize:'16px', fontWeight:'bold'}} to='/casa/admin_jurado_nov'> Novela  </NavLink>
            </Menu.Item>

            <Menu.Item style={{ fontWeight:'bold'}} >
            <NavLink style={{fontSize:'16px', fontWeight:'bold'}} to='/casa/admin_jurado_ens'> Ensayo  </NavLink>
            </Menu.Item>
         </SubMenu>
              <Menu.Item key="logout" icon={<LogoutOutlined style={{ fontSize: '26px'}} />}  >
              <a onClick={this.logout}style={{fontSize:'20px', fontWeight:'bold'}}> Cerrar sesión </a>
              </Menu.Item>
              
              </Menu>
            )
    return (

      <div className="page-container">
      <div className = "content-wrap">
      <ConfigProvider locale={es_ES}>
            <Layout style={{backgroundColor:'white'}}>
                
         
            
            


          <Row>
            <Col><NavLink to="/casa"><img src= {cabezal} style={{width:'100%', height:'100%'}}/></NavLink></Col>
          

          </Row>
          
          <Row>
            <Col span={24}>
            <Navbar menu={menu}/>

            
            </Col>
          </Row>
            <Content>
                <Table columns={columns}  bordered dataSource= {this.state.plays} pagination={{
            position: ["bottomCenter"],
          }} tableLayout='fixed' style={{ whiteSpace: 'normal'}} size="medium"  onChange = {this.handleTableChange}/>
                {
                    this.state.showArticle && 
                    <Modal 
                    closable = {false}
                        title={ this.state.record.title}
                        visible={this.state.showArticle} 
                        onCancel={this.hideModal}
                        footer={[
                            <Button key="back" onClick={this.hideModal}>
                            Regresar
                            </Button>,
                        ]}
                        >
                        <p><UserOutlined /> Nombre: {this.state.record.name}</p>
                        <p><MailOutlined /> Email: {this.state.record.email}</p>
                        <p><PhoneOutlined /> Teléfono: {this.state.record.phone}</p>
                        <p><GlobalOutlined /> País: {this.state.record.countryName}</p>
                        <p><EnvironmentOutlined /> Dirección: {this.state.record.address}</p>
                        <p><IdcardOutlined /> Ficha: {this.state.record.ficha}</p>
              
                    
                    </Modal>
                    }
                    { this.state.edit && <Modal 
                          closable = {false}
                          title={ this.state.record.title}
                          visible={this.state.edit} 
                          onCancel={this.hideEdit}
                          footer={[
                            <Button key="save" onClick={()=>this.onClickSave()}>
                            Guardar
                            </Button>,
                              <Button key="back" onClick={this.hideEdit}>
                              Regresar
                              </Button>,
                               
                          ]}
                          >
                         
                         <p><UserOutlined /> Nombre:<Input defaultValue= {this.state.record.name} id="nameInput" /> </p>
                        <p><MailOutlined /> Email:<Input defaultValue= {this.state.record.email} id="emailInput" /></p>
                        <p><PhoneOutlined /> Teléfono: <Input defaultValue= {this.state.record.phone} id="phoneInput" /> </p>
                        <p><GlobalOutlined /> País: <Select style={{width:'80%'}} showSearch defaultValue={this.state.record.country} onChange={(value)=>this.onChangeSelect(value)} >
                                  {countries["countries"].sort((a,b)=>a["name_es"].localeCompare(b["name_es"])).map((obj)=>{
                                    return <Option value={obj["code"]}>{obj["name_es"]}</Option>
                                })}
                                    
                                  </Select> </p>
                        <p><EnvironmentOutlined /> Dirección: <Input defaultValue= {this.state.record.address} id="addressInput" /></p>
                        <p><IdcardOutlined /> Ficha: <Input defaultValue= {this.state.record.ficha} id="fichaInput" /></p>

                       
  
                      </Modal>}
            </Content>
          </Layout>
         
        </ConfigProvider>
    </div>
    <Footer style={{backgroundColor:'#00b2e7', position:'relative',bottom:'0px',left:'0px',right:'0px',flexShrink:0}}>
          
          <Row justify="center" align="middle" style={{ width:'100%', backgroundColor:'#00b2e7',  marginBottom:'0px', bottom:'0px'}}>
          <Col xl={6} xs={24} sm={{span:6}}><div style={{textAlign: 'center'}}>  <NavLink to="/casa/admin_bases" style={{color:'white'}}>Bases del concurso</NavLink></div></Col>
          <Col  xl={4}xs={24} sm={{span:6}}><div style={{textAlign: 'center'}}><a style={{color:'white'}} href = "mailto: premiocasa@casa.cult.cu">premiocasa@casa.cult.cu</a></div></Col>
          <Col  xl={{span:4, offset:2}} sm={{span:6}} xs={{span:24}} ><div style={{textAlign: 'center'}}><a style={{color:'white', textAlign: 'center'}} target="_blank" href="http://www.casadelasamericas.org/"> Sitio Oficial Casa de las Américas</a> </div></Col>
          <Col xl={4}xs={24}sm={{span:6}} ><div style={{textAlign: 'center'}}><a style={{color:'white'}}target="_blank"  href="http://laventana.casa.cult.cu/"> La Ventana</a></div></Col>
          <Col  xl={4} xs={24} sm={{span:24}}><div style={{textAlign: 'center'}}> <NavLink to="/casa/admin_terminos" style={{color:'white'}}>Términos y condiciones de uso</NavLink></div></Col>
          
        </Row>
        </Footer>
    </div>

    );
  }
}
export default ConcList;


